import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { Row, Col, Button, Clearfix } from 'react-bootstrap';
import { find as _find, findIndex as _findIndex } from 'lodash';

import { getDescriptionInCurrentLanguage } from 'helpers/intl';
import { addNotification } from 'actions/NotificationsActions';
import { formStatusDispatchHelper } from 'actions/FormStatusActions';

import Data from 'components/Data';
import List from 'components/List';

import Breadcrumb from 'components/layout/Breadcrumb';
import Loader from 'components/layout/Loader';
import SepaAgreement from 'components/layout/sepa/SepaAgreement';
import SepaAgreementDetails from 'components/layout/sepa/SepaAgreementDetails';

import MyParentBankData from 'components/forms/clients/MyParentBankData';

class PluginSepaDetails extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      sepaCheckboxChecked: false,
    };
  }

  // check if current user's company has bank data
  hasBankData = () => {
    const { myParent } = this.props;
    if (!myParent.pending && myParent.data.financial && myParent.data.financial.bank_data) {
      const bankData = myParent.data.financial.bank_data;

      if (bankData.iban && bankData.swift_bic) {
        return true;
      }
    }

    return false;
  };

  hasSepaAgreement = () => {
    const { plugin, sepaAgreements } = this.props;
    if (plugin && !plugin.pending && !sepaAgreements.pending) {
      return _findIndex(sepaAgreements.data.list, { is_active: true, target: plugin.data.owner.id }) > -1;
    }

    return false;
  };

  getSepaAgreementData = () => {
    const { plugin, sepaAgreements } = this.props;
    if (plugin && !plugin.pending && !sepaAgreements.pending) {
      return _find(sepaAgreements.data.list, { is_active: true, target: plugin.data.owner.id });
    }

    return null;
  };

  componentDidUpdate = prevProps => {
    const {
      intl: { messages },
      appIntl,
      history,
      sepaAgreementNewFormStatus,
      doNotify,
    } = this.props;

    // if sepa agreement is sent and if it's successfull, notify the user and go back to plugin overview
    if (
      prevProps.sepaAgreementNewFormStatus.pending &&
      !sepaAgreementNewFormStatus.pending &&
      !sepaAgreementNewFormStatus.hasError
    ) {
      doNotify(1, messages.sepa_agreement_saved);
      history.push(appIntl.urlPrefix + 'account/settings/plugins');
    }
  };

  onSubmit = () => {
    const { plugin, submitSepaAgreementNew } = this.props;
    submitSepaAgreementNew({ target: { username: plugin.data.owner.id } });
  };

  render() {
    const {
      intl: { messages },
      appIntl,
      plugin,
      myParent,
      sepaAgreements,
      sepaAgreementNewFormStatus,
    } = this.props;

    const pending = myParent.pending || sepaAgreements.pending || plugin.pending;

    const hasBankData = this.hasBankData();
    const hasSepaAgreement = this.hasSepaAgreement();

    const header = !pending && (
      <div class="bg-master-lightest menuclipper padding-20 hidden-xs hidden-sm">
        <Row>
          <Col xs={4}>
            <Clearfix>
              <div class="pull-left font-secondary no-margin text-uppercase">{plugin.data.name}</div>
            </Clearfix>
          </Col>
          <Col xs={8}>
            <div class="font-secondary no-margin">
              {messages.price_from} {getDescriptionInCurrentLanguage(plugin.data.price_short_info, appIntl)}
            </div>
          </Col>
        </Row>
      </div>
    );

    return (
      <div class="padding-25 sm-padding-10">
        <Data dataName="myParent" url="/api/clients/parent.json" data={myParent} />
        <Data
          dataName="whiteLabelPlugin"
          url={'/api/whitelabelplugins/' + this.props.match.params.whiteLabelPluginId + '.json'}
          list={plugin}
        />
        <List noRender listName="sepaAgreements" url="/api/sepaagreements.json" list={sepaAgreements} />

        <Breadcrumb
          crumbs={[
            { link: appIntl.urlPrefix + 'account', name: 'Dashboard' },
            { link: appIntl.urlPrefix + 'account/settings', name: messages.settings },
            { link: appIntl.urlPrefix + 'account/settings/plugins', name: messages.plugins },
            { link: null, name: pending ? '' : messages.sepa_mandate + ' • ' + plugin.data.name },
          ]}
          className="p-t-0"
        />

        {pending ? (
          <Loader />
        ) : (
          <div>
            {/* if user has no sepa agreement and has no bank data, display a form to enter missing information */}
            {!hasBankData && !hasSepaAgreement && (
              <div class="panel b-rad-lg m-b-20">
                {header}
                <div class="panel-body">
                  <Row>
                    <Col xs={12} md={6} mdOffset={3}>
                      <h4>{messages.missing_companys_bank_data}</h4>

                      <MyParentBankData
                        parent={
                          myParent.data && myParent.data.financial && myParent.data.financial.bank_data
                            ? myParent.data.financial.bank_data
                            : {}
                        }
                      />
                    </Col>
                  </Row>
                </div>
              </div>
            )}

            {/* if user has no sepa agreement, display the form and infos to create one */}
            {hasBankData && !hasSepaAgreement && (
              <div class="panel b-rad-lg m-b-20">
                {header}

                <div class="panel-body">
                  <Row>
                    <Col xs={12}>
                      <h4>{messages.missing_sepa_mandate}</h4>

                      {/* The company has no SEPA agreement, we need to generate one */}
                      <SepaAgreement owner={plugin.data.owner} target={myParent.data} />

                      <div class="m-t-20 m-b-20">
                        <div class="checkbox check-success">
                          <input
                            disabled={pending}
                            id="sepaCheckbox"
                            name="sepaCheckbox"
                            type="checkbox"
                            value="true"
                            checked={this.state.sepaCheckboxChecked}
                            onChange={e => this.setState({ sepaCheckboxChecked: e.target.checked })}
                          />
                          <label for="sepaCheckbox">{messages.sepaAgreement.i_issue_sepa_direct_debit_mandate}</label>
                        </div>
                      </div>

                      {/* In order to activate the button, user needs to accept the costs and SEPA agreement */}
                      <Button
                        bsStyle="primary"
                        block
                        disabled={!this.state.sepaCheckboxChecked || sepaAgreementNewFormStatus.pending}
                        onClick={this.onSubmit}
                      >
                        {sepaAgreementNewFormStatus.pending ? (
                          <i class="fa-fw fa fa-circle-notch fa-spin m-r-5" />
                        ) : null}

                        {messages.save}
                      </Button>
                    </Col>
                  </Row>
                </div>
              </div>
            )}

            {/* if user has a sepa agreement, display the details */}
            {hasSepaAgreement && hasBankData && (
              <div class="panel b-rad-lg m-b-20">
                {header}

                <div class="panel-body">
                  <Row>
                    <Col xs={12} md={6} mdOffset={3}>
                      <h4>{messages.sepa_mandate}</h4>
                      <SepaAgreementDetails
                        owner={plugin.data.owner}
                        target={myParent.data}
                        sepaAgreement={this.getSepaAgreementData()}
                      />
                    </Col>
                  </Row>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    myParent: state.data.myParent,
    plugin: state.data.whiteLabelPlugin,
    sepaAgreements: state.list.sepaAgreements,
    sepaAgreementNewFormStatus: state.formStatus.sepaAgreementNew,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    doNotify: (code, text) => {
      dispatch(addNotification(code, text));
    },
    submitSepaAgreementNew: data => {
      formStatusDispatchHelper('sepaAgreementNew', '/api/sepaagreements.json', data, 'post', dispatch);
    },
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(PluginSepaDetails)
  )
);
